<template>
  <div class="ad">
    <template v-if="list[ad]">
      <p class="img" :style="{backgroundImage: 'url(' + list[ad].img + ')'}"></p>
      <p class="title">{{list[ad].title}}</p>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      ad: [String, Number]
    },
    data () {
      return {
        list: {
          '331': {
            title: '服饰',
            img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/07ca671d-c91f-43df-a617-e4c94456a531.jpg'
          },
          '341': {
            title: '醇酿',
            img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/87e105d3-61d1-4af8-a97c-be03acba833b.jpg'
          },
          '361': {
            title: '奢品',
            img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/ebbbbdb3-6daf-41f6-b301-2f5f15405c9c.jpg'
          },
          '1172': {
            title: '美妆',
            img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/e3de6243-e65b-48b7-a28d-e2b69d823ebd.jpg'
          },
          'canyin': {
            title: '餐饮',
            img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/fbef135f-80d9-40dd-a0ea-960081717af6.jpg'
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .ad {
    .img {
      height: 210px;
      background-color: #d8d8d8;
    }
    .title {
      width: 164px;
      height: 40px;
      line-height: 40px;
      margin: -20px auto 0;
      text-align: center;
      background: rgba(0,0,0,.9);
      color: white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/ad.vue